// extracted by mini-css-extract-plugin
export default {"after":"FormTextInput_after__2YIG-"};